'use strict';

(function () {

  // ── Header bar controller ─────────────────────────────────────

  function initHeaderBar() {
    var barSelector  = document.getElementById('ymm-bar-selector');
    var barChip      = document.getElementById('ymm-bar-chip');
    var barChipLabel = document.getElementById('ymm-bar-chip-label');
    var barClear     = document.getElementById('ymm-bar-chip-clear');
    var barYear      = document.getElementById('ymm-bar-year');
    var barMake      = document.getElementById('ymm-bar-make');
    var barModel     = document.getElementById('ymm-bar-model');
    var barConfirm   = document.getElementById('ymm-bar-confirm');
    var mobileOpen   = document.getElementById('ymm-bar-mobile-open');

    if (!barSelector) return;

    function populateBarYears() {
      if (!barYear || !window.YMMEngine) return;
      barYear.innerHTML = '<option value="">Year</option>';
      window.YMMEngine.getYears().forEach(function (y) {
        var opt = document.createElement('option');
        opt.value = y; opt.textContent = y;
        barYear.appendChild(opt);
      });
      restoreBarSelections();
    }

    function restoreBarSelections() {
      var vehicle = window.FitmentStorage ? window.FitmentStorage.getVehicle() : null;
      if (!vehicle || !barYear) return;
      barYear.value = vehicle.year;
      barYear.dispatchEvent(new Event('change'));
      setTimeout(function () {
        if (!barMake) return;
        barMake.value = vehicle.make;
        barMake.dispatchEvent(new Event('change'));
        setTimeout(function () {
          if (!barModel) return;
          barModel.value = vehicle.model;
          if (barConfirm) barConfirm.disabled = false;
        }, 0);
      }, 0);
    }

    if (window.YMMEngine && window.YMMEngine.state === 'ready') {
      populateBarYears();
    }
    document.addEventListener('ymm:ready', populateBarYears);

    if (barYear) {
      barYear.addEventListener('change', function () {
        barMake.innerHTML = '<option value="">Make</option>';
        barModel.innerHTML = '<option value="">Model</option>';
        barMake.disabled = true; barModel.disabled = true;
        if (barConfirm) barConfirm.disabled = true;
        if (!barYear.value || !window.YMMEngine) return;
        window.YMMEngine.getMakes(barYear.value).sort().forEach(function (m) {
          var opt = document.createElement('option');
          opt.value = m; opt.textContent = m;
          barMake.appendChild(opt);
        });
        barMake.disabled = false;
      });
    }

    if (barMake) {
      barMake.addEventListener('change', function () {
        barModel.innerHTML = '<option value="">Model</option>';
        barModel.disabled = true;
        if (barConfirm) barConfirm.disabled = true;
        if (!barMake.value || !window.YMMEngine) return;
        window.YMMEngine.getModels(barYear.value, barMake.value).sort().forEach(function (m) {
          var opt = document.createElement('option');
          opt.value = m; opt.textContent = m;
          barModel.appendChild(opt);
        });
        barModel.disabled = false;
      });
    }

    if (barModel) {
      barModel.addEventListener('change', function () {
        if (barConfirm) barConfirm.disabled = !barModel.value;
      });
    }

    if (barConfirm) {
      barConfirm.addEventListener('click', function () {
        if (!barYear || !barYear.value || !barMake.value || !barModel.value) return;
        var fitment = window.YMMEngine
          ? window.YMMEngine.lookup(barYear.value, barMake.value, barModel.value)
          : null;
        window.FitmentStorage.saveVehicle(barYear.value, barMake.value, barModel.value, fitment);
        var sku = fitment ? fitment.sku : null;

        // Already on compatible-products page: update URL in-place and re-filter
        var gridContainer = document.getElementById('ProductGridContainer');
        if (gridContainer && gridContainer.dataset.fitmentCollection) {
          var url = new URL(window.location.href);
          url.searchParams.set('ymm_sku', sku);
          history.replaceState(null, '', url.pathname + url.search);
          if (window.FitmentFilter) window.FitmentFilter.run();
          return;
        }

        // On PDP: try to redirect to the matched variant on the same product
        /* var pdpMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
        if (pdpMatch) {
          var productHandle = pdpMatch[1];
          fetch('/products/' + productHandle + '.js')
            .then(function (r) { return r.json(); })
            .then(function (product) {
              var matched = null;
              for (var i = 0; i < product.variants.length; i++) {
                if (product.variants[i].sku === sku) { matched = product.variants[i]; break; }
              }
              if (matched) {
                window.location.href = '/products/' + productHandle + '?variant=' + matched.id + '&ymm_sku=' + encodeURIComponent(sku);
              }
              // No match: vehicle already saved, stay on page — applyVariantLock shows incompatible banner
            })
            .catch(function () {
              // On fetch error: stay on page, vehicle already saved
            });
          return;
        } */

        // On PDP: close drawer and trigger variant lock, stay on page
        if (window.location.pathname.indexOf('/products/') === 0) {
          // Trigger variant lock to apply fitment to current product
          if (window.FitmentFilter && window.FitmentFilter.applyVariantLock) {
            window.FitmentFilter.applyVariantLock();
          }
          return;
        }

        // Not on PDP or compatible-products: redirect to collection
        window.location.href = '/collections/compatible-products?ymm_sku=' + encodeURIComponent(sku);
      });
    }

    if (mobileOpen) {
      mobileOpen.addEventListener('click', function () {
        if (window.FitmentGuard) window.FitmentGuard.openDrawer();
      });
    }

    if (barClear) {
      barClear.addEventListener('click', function () {
        if (window.FitmentStorage) window.FitmentStorage.clearVehicle();
      });
    }

    // Sync bar state when vehicle changes
    document.addEventListener('ymm:changed', function (e) {
      var vehicle = e.detail && e.detail.vehicle;
      if (vehicle) {
        var label = vehicle.year + ' ' + vehicle.make + ' ' + vehicle.model;
        if (barChipLabel) barChipLabel.textContent = label;
        if (barChip)     barChip.classList.add('visible');
        if (barSelector) barSelector.classList.add('hidden');
        // Update mobile trigger button text to show selected vehicle
        if (mobileOpen) {
          mobileOpen.querySelector('span').textContent = label;
        }
      } else {
        if (barChip)     barChip.classList.remove('visible');
        if (barSelector) barSelector.classList.remove('hidden');
        if (barYear)    barYear.value = '';
        if (barMake)  { barMake.innerHTML = '<option value="">Make</option>'; barMake.disabled = true; }
        if (barModel) { barModel.innerHTML = '<option value="">Model</option>'; barModel.disabled = true; }
        if (barConfirm) barConfirm.disabled = true;
        // Reset mobile trigger button text
        if (mobileOpen) {
          mobileOpen.querySelector('span').textContent = 'Select Vehicle';
        }
      }
    });

    // Sync initial state on page load (after YMMEngine is ready)
    function syncInitialState() {
      var initialVehicle = window.FitmentStorage ? window.FitmentStorage.getVehicle() : null;
      if (initialVehicle) {
        var label = initialVehicle.year + ' ' + initialVehicle.make + ' ' + initialVehicle.model;
        if (barChipLabel) barChipLabel.textContent = label;
        if (barChip)     barChip.classList.add('visible');
        if (barSelector) barSelector.classList.add('hidden');
        // Update mobile trigger button text to show selected vehicle
        if (mobileOpen) {
          mobileOpen.querySelector('span').textContent = label;
        }
      }
    }

    if (window.YMMEngine && window.YMMEngine.state === 'ready') {
      syncInitialState();
    }
    document.addEventListener('ymm:ready', syncInitialState);
  }

  // ── YMM Drawer form controller ────────────────────────────────

  function initDrawerForm() {
    var loading    = document.getElementById('ymm-loading');
    var fetchError = document.getElementById('ymm-fetch-error');
    var fields     = document.getElementById('ymm-fields');
    var yearSel    = document.getElementById('truck-year');
    var makeSel    = document.getElementById('truck-make');
    var modelSel   = document.getElementById('truck-model');
    var confirmBtn = document.getElementById('ymm-confirm');

    if (!yearSel) return;

    function showLoading() {
      if (loading)    loading.classList.add('visible');
      if (fetchError) fetchError.classList.remove('visible');
      if (fields)     fields.style.display = 'none';
    }

    function showFields() {
      if (loading)    loading.classList.remove('visible');
      if (fetchError) fetchError.classList.remove('visible');
      if (fields)     fields.style.display = '';
    }

    function showFetchError() {
      if (loading)    loading.classList.remove('visible');
      if (fetchError) fetchError.classList.add('visible');
      if (fields)     fields.style.display = 'none';
    }

    function populateYears() {
      if (!yearSel || !window.YMMEngine) return;
      yearSel.innerHTML = '<option value="">Select year</option>';
      window.YMMEngine.getYears().forEach(function (y) {
        var opt = document.createElement('option');
        opt.value = y; opt.textContent = y;
        yearSel.appendChild(opt);
      });
    }

    if (window.YMMEngine && window.YMMEngine.state === 'ready') {
      populateYears(); showFields();
    } else if (window.YMMEngine && window.YMMEngine.state === 'error') {
      showFetchError();
    } else {
      showLoading();
    }

    document.addEventListener('ymm:ready', function () { populateYears(); showFields(); });
    document.addEventListener('ymm:error', function () { showFetchError(); });

    if (yearSel) {
      yearSel.addEventListener('change', function () {
        makeSel.innerHTML = '<option value="">Select make</option>';
        modelSel.innerHTML = '<option value="">Select model</option>';
        makeSel.disabled = true; modelSel.disabled = true;
        if (confirmBtn) confirmBtn.disabled = true;
        if (!yearSel.value || !window.YMMEngine) return;
        window.YMMEngine.getMakes(yearSel.value).sort().forEach(function (m) {
          var opt = document.createElement('option');
          opt.value = m; opt.textContent = m;
          makeSel.appendChild(opt);
        });
        makeSel.disabled = false;
      });
    }

    if (makeSel) {
      makeSel.addEventListener('change', function () {
        modelSel.innerHTML = '<option value="">Select model</option>';
        modelSel.disabled = true;
        if (confirmBtn) confirmBtn.disabled = true;
        if (!makeSel.value || !window.YMMEngine) return;
        window.YMMEngine.getModels(yearSel.value, makeSel.value).sort().forEach(function (m) {
          var opt = document.createElement('option');
          opt.value = m; opt.textContent = m;
          modelSel.appendChild(opt);
        });
        modelSel.disabled = false;
      });
    }

    if (modelSel) {
      modelSel.addEventListener('change', function () {
        if (confirmBtn) confirmBtn.disabled = !modelSel.value;
      });
    }

    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        var y = yearSel.value, m = makeSel.value, mo = modelSel.value;
        var hasError = false;
        [['truck-year', y], ['truck-make', m], ['truck-model', mo]].forEach(function (pair) {
          var errEl = document.getElementById(pair[0] + '--error');
          if (!pair[1]) {
            if (errEl) errEl.classList.add('visible');
            hasError = true;
          } else {
            if (errEl) errEl.classList.remove('visible');
          }
        });
        if (hasError) return;
        var fitment = window.YMMEngine ? window.YMMEngine.lookup(y, m, mo) : null;
        window.FitmentStorage.saveVehicle(y, m, mo, fitment);
        var sku = fitment ? fitment.sku : null;

        // Already on compatible-products page: update URL in-place and re-filter
        var gridContainer = document.getElementById('ProductGridContainer');
        if (gridContainer && gridContainer.dataset.fitmentCollection) {
          var url = new URL(window.location.href);
          url.searchParams.set('ymm_sku', sku);
          history.replaceState(null, '', url.pathname + url.search);
          if (window.FitmentFilter) window.FitmentFilter.run();
          // Close drawer after confirming
          if (window.FitmentGuard && window.FitmentGuard.closeDrawer) {
            window.FitmentGuard.closeDrawer();
          }
          return;
        }

        // On PDP: close drawer and trigger variant lock, stay on page
        if (window.location.pathname.indexOf('/products/') === 0) {
          // Close drawer after confirming
          if (window.FitmentGuard && window.FitmentGuard.closeDrawer) {
            window.FitmentGuard.closeDrawer();
          }
          // Trigger variant lock to apply fitment to current product
          if (window.FitmentFilter && window.FitmentFilter.applyVariantLock) {
            window.FitmentFilter.applyVariantLock();
          }
          return;
        }

        // Not on PDP or compatible-products: redirect to collection
        window.location.href = '/collections/compatible-products?ymm_sku=' + encodeURIComponent(sku);
      });
    }

    // Pre-fill drawer fields if vehicle already selected
    document.addEventListener('ymm-drawer:open', function () {
      var vehicle = window.FitmentStorage ? window.FitmentStorage.getVehicle() : null;
      if (!vehicle || !yearSel) return;
      yearSel.value = vehicle.year;
      yearSel.dispatchEvent(new Event('change'));
      setTimeout(function () {
        makeSel.value = vehicle.make;
        makeSel.dispatchEvent(new Event('change'));
        setTimeout(function () {
          modelSel.value = vehicle.model;
          if (confirmBtn) confirmBtn.disabled = false;
        }, 0);
      }, 0);
    });
  }

  function initStickyBarShadow() {
    var bar = document.querySelector('.ymm-header-bar');
    if (!bar) return;

    // Create a placeholder to fill space when bar goes fixed
    var placeholder = document.createElement('div');
    placeholder.className = 'ymm-header-bar-placeholder';
    bar.parentNode.insertBefore(placeholder, bar.nextSibling);

    function getHeaderHeight() {
      return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    }

    function updateBarState() {
      var barSection = bar.closest('.ymm-header-bar-section') || bar.parentNode;
      var sectionTop = barSection.getBoundingClientRect().top;
      var headerHeight = getHeaderHeight();

      if (sectionTop <= headerHeight) {
        // Bar has scrolled past its natural position — fix it
        placeholder.style.height = bar.offsetHeight + 'px';
        placeholder.classList.add('ymm-header-bar-placeholder--active');
        bar.classList.add('ymm-header-bar--fixed');
        // Keep top in sync with --header-height (handles resize)
        bar.style.top = headerHeight + 'px';
      } else {
        placeholder.classList.remove('ymm-header-bar-placeholder--active');
        bar.classList.remove('ymm-header-bar--fixed');
        bar.style.top = '';
      }
    }

    window.addEventListener('scroll', updateBarState, { passive: true });
    window.addEventListener('resize', updateBarState, { passive: true });
    updateBarState();
  }

  // ── Hide YMM bar when nav dropdown is open (native select overlap fix) ──

  function initNavBarConflict() {
    var bar = document.querySelector('.ymm-header-bar');
    if (!bar) return;

    // Target the nav container itself — covers all menu items with submenus
    var navContainer = document.querySelector('.thb-full-menu');
    if (!navContainer) return;

    function hideBar() {
      // Close any open native select dropdown
      var active = bar.querySelector('select:focus');
      if (active) active.blur();
      bar.classList.add('ymm-header-bar--nav-active');
    }

    function showBar() {
      bar.classList.remove('ymm-header-bar--nav-active');
    }

    // Listen on each menu item with children
    var items = navContainer.querySelectorAll('.menu-item-has-children');
    items.forEach(function (item) {
      item.addEventListener('mouseenter', hideBar);
      item.addEventListener('mouseleave', showBar);
    });

    // Also listen on the full-menu element for focus-within (keyboard nav)
    navContainer.addEventListener('focusin', function (e) {
      if (e.target.closest('.menu-item-has-children')) hideBar();
    });
    navContainer.addEventListener('focusout', function (e) {
      setTimeout(function () {
        if (!navContainer.querySelector('.menu-item-has-children:hover')) showBar();
      }, 50);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeaderBar();
    initDrawerForm();
    initStickyBarShadow();
    initNavBarConflict();
  });

  // Re-init drawer form when quick view injects content
  document.addEventListener('quick-view:open', function () {
    initDrawerForm();
    updateATCLabels();
  });

  // ── ATC label swap for mandatory fitment products ──────────────

  function _isMandatoryBtn(btn) {
    if (!window.YMM_MANDATORY_HANDLES || !window.YMM_MANDATORY_HANDLES.length) return false;
    var variantId = btn.dataset.variantId;
    if (variantId && window.YMM_PRODUCT_VARIANT_MAP) {
      var handle = window.YMM_PRODUCT_VARIANT_MAP[variantId];
      if (handle) return window.YMM_MANDATORY_HANDLES.indexOf(handle) !== -1;
    }
    return false;
  }

  function updateATCLabels() {
    var hasVehicle = !!(window.FitmentStorage && window.FitmentStorage.getVehicle());
    var addToCartLabel = (window.theme && window.theme.variantStrings && window.theme.variantStrings.addToCart) || 'Add to cart';

    // PDP and main ATC buttons
    var buttons = document.querySelectorAll('button.single-add-to-cart-button[data-variant-id]');
    if (buttons.length) {
      buttons.forEach(function (btn) {
        if (btn.disabled) return;
        if (!_isMandatoryBtn(btn)) return;
        var textSpan = btn.querySelector('.single-add-to-cart-button--text');
        if (!textSpan) return;
        if (!hasVehicle) {
          if (!btn.dataset.atcLabel) btn.dataset.atcLabel = textSpan.textContent.trim();
          textSpan.textContent = addToCartLabel;
          btn.dataset.ymmGuard = 'true';
          if (btn.type !== 'button') btn.dataset.atcType = btn.type;
          btn.type = 'button';
        } else {
          if (btn.dataset.atcLabel) textSpan.textContent = btn.dataset.atcLabel;
          if (btn.dataset.atcType) btn.type = btn.dataset.atcType;
          delete btn.dataset.ymmGuard;
        }
      });
    }

    // Small card ATC buttons
    var smallCardBtns = document.querySelectorAll('.product-card-small--add-to-cart-button');
    if (smallCardBtns.length) {
      smallCardBtns.forEach(function (btn) {
        var card = btn.closest('.product-card-small');
        var handle = card ? card.dataset.productHandle : null;
        if (!handle || !window.YMM_MANDATORY_HANDLES) return;
        if (window.YMM_MANDATORY_HANDLES.indexOf(handle) === -1) return;

        var textSpan = btn.querySelector('.product-card-small--add-to-cart-text');
        if (!textSpan) return;
        if (!hasVehicle) {
          if (!btn.dataset.atcLabel) btn.dataset.atcLabel = textSpan.textContent.trim();
          textSpan.textContent = addToCartLabel;
          btn.dataset.ymmGuard = 'true';
        } else {
          if (btn.dataset.atcLabel) textSpan.textContent = btn.dataset.atcLabel;
          delete btn.dataset.ymmGuard;
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', updateATCLabels);
  document.addEventListener('ymm:ready',     updateATCLabels);
  document.addEventListener('ymm:confirmed', updateATCLabels);
  document.addEventListener('ymm:cleared',   updateATCLabels);

  // MutationObserver for dynamically loaded small cards
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes.length) {
        var hasSmallCard = false;
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            if (node.classList && node.classList.contains('product-card-small')) {
              hasSmallCard = true;
            } else if (node.querySelector && node.querySelector('.product-card-small')) {
              hasSmallCard = true;
            }
          }
        });
        if (hasSmallCard) {
          updateATCLabels();
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Direct click guard: block ANY ATC button flagged as requiring vehicle selection
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.product-card-small--add-to-cart-button, .single-add-to-cart-button');
    if (!btn) return;
    if (btn.dataset.ymmGuard !== 'true') return;

    e.preventDefault();
    e.stopPropagation();
    if (window.FitmentGuard && window.FitmentGuard.openDrawer) {
      window.FitmentGuard.openDrawer();
    }
  }, true);

  // Global submit guard as a fallback for any add-to-cart form
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.dataset.type !== 'add-to-cart-form') return;

    var btn = form.querySelector('.single-add-to-cart-button');
    if (!btn) {
      var stickyBtn = document.getElementById('AddToCartSticky');
      if (stickyBtn && stickyBtn.form === form) btn = stickyBtn;
    }
    if (!btn) return;

    if (btn.dataset.ymmGuard !== 'true') return;

    e.preventDefault();
    e.stopPropagation();
    if (window.FitmentGuard && window.FitmentGuard.openDrawer) {
      window.FitmentGuard.openDrawer();
    }
  }, true);

  // ── Line item properties sync ──────────────────────────────────

  function syncLineItemProperties() {
    var vehicle = window.FitmentStorage ? window.FitmentStorage.getVehicle() : null;
    var vehicleEl = document.getElementById('fitment-prop-vehicle');
    var yearEl = document.getElementById('fitment-prop-year');
    var makeEl = document.getElementById('fitment-prop-make');
    var modelEl = document.getElementById('fitment-prop-model');
    var statusEl = document.getElementById('fitment-prop-status');
    var skuEl = document.getElementById('fitment-prop-sku');

    if (!yearEl) return;

    if (vehicle) {
      var label = [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ');
      if (vehicleEl) vehicleEl.value = label;
      yearEl.value = vehicle.year || '';
      makeEl.value = vehicle.make || '';
      modelEl.value = vehicle.model || '';
      statusEl.value = vehicle.fitment ? vehicle.fitment.status : '';
      skuEl.value = vehicle.fitment ? vehicle.fitment.sku : '';
    } else {
      if (vehicleEl) vehicleEl.value = '';
      yearEl.value = '';
      makeEl.value = '';
      modelEl.value = '';
      statusEl.value = '';
      skuEl.value = '';
    }
  }

  // ── Append vehicle property to AJAX cart FormData ─────────────
  // Called by app.js quickAdd / addToCart before fetch

  window.FitmentAppendVehicle = function (formData, productHandle) {
    if (!formData || !window.FitmentStorage) return;
    var vehicle = window.FitmentStorage.getVehicle();
    if (!vehicle) return;

    // Only attach fitment properties to mandatory fitment products.
    // Resolve handle from param, else the PDP variant→handle map.
    var handle = productHandle;
    if (!handle && window.YMM_PRODUCT_VARIANT_MAP) {
      handle = window.YMM_PRODUCT_VARIANT_MAP[formData.get('id')];
    }
    if (!window.YMM_MANDATORY_HANDLES || !handle || window.YMM_MANDATORY_HANDLES.indexOf(handle) === -1) return;

    var label = [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ');
    var status = '';
    var sku = '';

    // Try to get fitment status if YMMEngine is available (PDP)
    if (window.YMMEngine) {
      var fitment = window.YMMEngine.lookup(vehicle.year, vehicle.make, vehicle.model);
      if (fitment) {
        sku = fitment.sku || '';
        var variantId = formData.get('id');
        var variantSku = null;

        var el = document.querySelector('variant-selects [type="application/json"]');
        if (el) {
          try {
            var variants = JSON.parse(el.textContent);
            for (var i = 0; i < variants.length; i++) {
              if (String(variants[i].id) === String(variantId)) {
                variantSku = variants[i].sku || null;
                break;
              }
            }
          } catch (e) {}
        }

        status = (variantSku && variantSku.toLowerCase() === fitment.sku.toLowerCase()) ? 'Confirmed Fitment' : 'Pending Review';
      }
    }

    // Delete any existing values to avoid duplicate keys, then append fresh values
    formData.delete('properties[Vehicle]');
    formData.delete('properties[Fitment Status]');
    formData.delete('properties[_Vehicle Year]');
    formData.delete('properties[_Vehicle Make]');
    formData.delete('properties[_Vehicle Model]');
    formData.delete('properties[_Fitment Status]');
    formData.delete('properties[_Fitment SKU]');

    if (label) formData.append('properties[Vehicle]', label);
    if (status) formData.append('properties[Fitment Status]', status);
    if (status) formData.append('properties[_Fitment Status]', status);
    if (vehicle.year) formData.append('properties[_Vehicle Year]', vehicle.year);
    if (vehicle.make) formData.append('properties[_Vehicle Make]', vehicle.make);
    if (vehicle.model) formData.append('properties[_Vehicle Model]', vehicle.model);
    if (sku) formData.append('properties[_Fitment SKU]', sku);
  };

  document.addEventListener('DOMContentLoaded', syncLineItemProperties);
  document.addEventListener('ymm:ready', syncLineItemProperties);
  document.addEventListener('ymm:confirmed', syncLineItemProperties);
  document.addEventListener('ymm:cleared', syncLineItemProperties);
  document.addEventListener('quick-view:open', function () {
    setTimeout(syncLineItemProperties, 60);
  });

})();
